import { isNativeIOS, NativeRuntime, setNativeDemo } from './platform';

export async function prepareNative() {
  if (!isNativeIOS()) return;
  document.documentElement.classList.add('native-ios');
  const { demo, demoSupported, live } = await NativeRuntime.info();
  if (demo) { localStorage.setItem("goopa:native-demo-enabled", "1"); localStorage.removeItem("goopa:native-demo-disabled"); }
  if (live) localStorage.setItem("goopa:native-demo-disabled", "1");
  if (!demoSupported || localStorage.getItem('goopa:native-demo-enabled') !== '1' || localStorage.getItem('goopa:native-demo-disabled') === '1') return;
  // Only a Debug simulator launched with --goopa-demo can enter this mode.
  setNativeDemo(true);
  const { db } = await import('../lib/db');
  const { setLanguage } = await import('../i18n/core');
  const firstDemo = !(await db.profile.get('me'));
  if (firstDemo) setLanguage('it');
  const { ensureProfile, updateProfile } = await import('../lib/repo');
  await ensureProfile();
  if (!(await db.trips.count())) {
    const { seedDemoTrip } = await import('../data/demo');
    const tripId = await seedDemoTrip();
    await db.trips.update(tripId, {destination: 'Kyoto', timeZone: 'Asia/Tokyo', localCurrency: 'JPY'});
  }
  if (firstDemo) await updateProfile({ name: 'Esploratore', language: 'it', onboardingCompletedAt: new Date().toISOString() });
  // A saved local plan lets the simulator exercise editing without calling AI.
  // This runs only in the isolated demo database and never replaces a plan.
  if (!(await db.settings.get('native-demo-plan-seeded'))) {
    const trip = await db.trips.filter(row => row.isDemo === true && !row.deletedAt).first();
    if (trip) {
      const key = `itinerary:${trip.id}`;
      if (!(await db.settings.get(key))) {
        const stages = await db.stages.where('tripId').equals(trip.id).sortBy('sortIndex');
        const todos = await db.todos.where('tripId').equals(trip.id).sortBy('sortIndex');
        const plan: import('../lib/itinerary').SavedItinerary = {
          tripId: trip.id, createdAt: new Date().toISOString(), sourceIds: todos.map(row => row.id), leftOut: [],
          days: stages.map(stage => ({
            date: stage.startDate ?? trip.startDate ?? null,
            slots: todos.filter(row => row.stageId === stage.id).map((row, index) => ({
              todoId: row.id, when: index < 2 ? 'morning' : index < 4 ? 'afternoon' : 'evening',
            })),
          })),
        };
        await db.settings.put({key, value: plan});
      }
    }
    await db.settings.put({key: 'native-demo-plan-seeded', value: true});
  }
}
